export default __webpack_public_path__ + "static/media/no-pic-sm.8ea9d90e.svg";